export default "__VITE_ASSET__pOtIWnJF__"